export type AdobeExperienceProps = {
    experience: string;
    isdefault?: boolean;
};
export default function AdobeABExperience({
    experience,
    isdefault = false,
    children,
}: React.PropsWithChildren<AdobeExperienceProps>) {
    return <>{children}</>;
}
